// extracted by mini-css-extract-plugin
export default {"overlay":"qB-z","bodyOpen":"rB-z","content":"sB-z","header":"tB-z","close":"uB-z","closeNoHeading":"vB-z"};